export default "__VITE_ASSET__zuM_VnPB__"